import api from "@/services/api";
import {
  PaginatedTransactionsResponse,
  TransactionFiltersRequest,
  Transactions,
} from "@/types/transaction/Transaction";

class GetTransaction {
  execute(
    ibge?: string | number,
    startDate?: string,
    endDate?: string
  ): Promise<Transactions[]>;
  execute(
    filters: TransactionFiltersRequest
  ): Promise<Transactions[] | PaginatedTransactionsResponse>;
  async execute(
    ibgeOrFilters?: string | number | TransactionFiltersRequest,
    startDate?: string,
    endDate?: string
  ): Promise<Transactions[] | PaginatedTransactionsResponse> {
    const filters =
      typeof ibgeOrFilters === "object" && ibgeOrFilters !== null
        ? ibgeOrFilters
        : {
            ibge: ibgeOrFilters,
            startDate,
            endDate,
            status: "CONFIRMED",
            type: "PAYMENT",
          };

    const normalizedFilters = {
      ...filters,
      paginate:
        typeof filters.paginate === "boolean"
          ? String(filters.paginate)
          : filters.paginate,
    };

    const transactions = await api().get("transactions", {
      params: normalizedFilters,
    });

    return transactions.data;
  }
}

export { GetTransaction };
